import { useMemo } from "react";
import { useTests } from "../hooks/useTests";
import { MockTestList } from "../mocktest/list";
import { AIModal } from "./AIModal";
import { useEvaluate } from "../hooks/useEvaluate";
import { ArrowBack } from "@material-ui/icons";

const MockExamModal = ({ grade, section, handleClose }) => {
  const { exams, loading, setPage } = useTests({ grade, section });
  const {
    examLink,
    examLoading,
    examError,
    openExam,
    openModal,
    closeExam,
    selectedExamId,
  } = useEvaluate({ grade, section });

  const filteredList = useMemo(() => {
    return exams.filter((exam) => {
      if (![2, 5].includes(exam.examType)) return false;
      if (exam?.documents?.[0]?.url) return true;
      return false;
    });
  }, [exams]);

  return (
    <>
      <AIModal onClose={handleClose} className={'overflow-auto'}>
        {!examLink && !examLoading && !examError ? (
          <MockTestList
            loading={loading}
            list={filteredList}
            evaluateExam={openExam}
            onPageChange={setPage}
          />
        ) : null}

        {examLoading && (
          <div className="exam-loader-container">
            <div className="exam-loader"></div>
            <p>Loading exam...</p>
          </div>
        )}

        {!examLoading && !examError && examLink && (
          <>
            <div className="exam-header">
              <div className="exam-header-left">
                <button className="exam-back-btn" onClick={closeExam}>
                  <ArrowBack fontSize="small" />
                  Back
                </button>
              </div>
            </div>
            <iframe
              title="Exam"
              src={examLink}
              className="exam-iframe"
              allowFullScreen
            />
          </>
        )}
      </AIModal>
    </>
  );
};

export default MockExamModal;
